import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=44a91164"
import script from "./GroupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports